export default __webpack_public_path__ + "static/media/loader1.79c1ac59.gif";